import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { useRegistration } from '../context/RegistrationContext';
import MarketingHeading from './shared/MarketingHeading';

const NotFoundPage: React.FC = () => {
  const { isRegistered } = useRegistration();
  const location = useLocation();

  return (
    <Box
      component="section"
      aria-labelledby="not-found-heading"
      sx={{ py: { xs: 4, md: 6 }, textAlign: 'center', maxWidth: 560, mx: 'auto' }}
    >
      <MarketingHeading id="not-found-heading" level="h1" gutterBottom>
        Page not found
      </MarketingHeading>
      <Typography color="text.secondary" sx={{ mb: 3 }}>
        We could not find <strong>{location.pathname}</strong>. Check the URL for typos or open a section from the
        menu.
      </Typography>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} justifyContent="center">
        <Button component={RouterLink} to={isRegistered ? '/dashboard' : '/login'} variant="contained" size="large">
          {isRegistered ? 'Go to dashboard' : 'Go to login'}
        </Button>
        <Button component={RouterLink} to="/help" variant="outlined" size="large">
          Help center
        </Button>
      </Stack>
    </Box>
  );
};

export default NotFoundPage;
